import { render, staticRenderFns } from "./ChatChart.vue?vue&type=template&id=72537bde"
import script from "./ChatChart.vue?vue&type=script&lang=js"
export * from "./ChatChart.vue?vue&type=script&lang=js"
import style0 from "./ChatChart.vue?vue&type=style&index=0&id=72537bde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports